
import { RotateCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "@/components/ui/tooltip";
import Icon from "@/components/ui/icon";

interface RefreshButtonProps {
  onClick: () => void;
  isRefreshing?: boolean;
  tooltip?: string;
}

const RefreshButton = ({ onClick, isRefreshing = false, tooltip = "Refresh" }: RefreshButtonProps) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button 
            variant="outline" 
            size="icon" 
            onClick={onClick}
            disabled={isRefreshing}
            className="w-10 h-10 p-0 rounded-xl bg-muted hover:bg-accent border-border"
          >
            <Icon 
              icon={RotateCw} 
              size={16} 
              className={`text-muted-foreground ${isRefreshing ? 'animate-spin' : ''}`}
            />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default RefreshButton;
